import React from 'react'
import './general-banner.scss'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'

const GeneralBanner = ({ bannerInfo, color }) => {
  const isMobile = useMediaQuery()

  const dataLayerBannerSecondRY = (redirect, name) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Banners_VConfident',
      category: 'banner_secundario',
      action: 'click',
      label: redirect,
      banner_name: name,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  return (
    <div className={`f-banner ${color}`}>
      <a
        className="f-banner__image"
        onClick={e => {
          e.preventDefault()
          dataLayerBannerSecondRY(siteUrl + '/' + bannerInfo.redireccionBannerMuestraGratis, 'Somos tu confidente')
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'ga_event',
            category: 'V-Confident :: Home',
            action: 'Click :: Banner Inferior',
            label: 'Quiero una muestra',
            value: '',
          })
          window.location.href =
            siteUrl + '/' + bannerInfo.redireccionBannerMuestraGratis
        }}
        href={siteUrl + '/' + bannerInfo.redireccionBannerMuestraGratis}
      >
        <GatsbyImage
          image={getImage(bannerInfo.bannerMuestraGratis[isMobile ? 1 : 0])}
          alt="Somos tu confidente"
          className="f-banner__image-img"
        />
      </a>
    </div>
  )
}

export default GeneralBanner
